import httpClient from '../axios/index';

class ApplicationService {
  getAppsList() {
    return httpClient.get('GetPublisherApps');
  }
}

export default new ApplicationService();
